import React from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import dynamic from 'next/dynamic';

const ReactQueryDevTools = dynamic(() =>
  import(
    /* webpackChunkName: "ReactQueryDevTools" */ '../shared/components/ReactQueryDevTools/ReactQueryDevTools'
  )
);

/**
 * @type {import('@tanstack/react-query').QueryClientConfig}
 */
const reactQueryConfig = {
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      // Retries are handled by our custom `fetch` client
      retry: false,
    },
  },
};

// Note: This will work for client side queries, if we want to use `react-query` during SSR
// to do prefetching, this will need to be rewritten into a custom extension so the same
// query client can be used across the different parts of `getInitialProps`
const withReactQueryProvider = (App) => {
  const getInitialProps = App.getInitialProps;

  function WithReactQueryProvider(props) {
    const [queryClient] = React.useState(
      () => new QueryClient(reactQueryConfig)
    );

    return (
      <QueryClientProvider client={queryClient}>
        <App {...props} />
      </QueryClientProvider>
    );
  }

  if (getInitialProps) {
    WithReactQueryProvider.getInitialProps = getInitialProps;
  }

  return WithReactQueryProvider;
};

export default function tanstackQueryExtension() {
  return {
    id: 'tanstackQueryExtension',
    admin: {
      panels: [<ReactQueryDevTools key="rq" />],
    },
    app: {
      enhance(App) {
        return withReactQueryProvider(App);
      },
    },
  };
}
